import {
  AUTH_BOOTSTRAP_FAILED,
  AUTH_INITIALIZED,
  CURRENT_ORG_UPDATED,
  PROFILE_UPDATED,
  SIGNED_OUT,
  START_MANAGING_ORG,
  USER_SWITCH_FINISHED,
  USER_SWITCH_STARTED,
} from './actions'

const defaultState = {
  initialized: false,
  bootstrapFailed: false,
  currentUser: null,
  currentOrganization: null,
  currentProfile: null,
  switchingUser: false,
}

export default function (state = defaultState, event) {
  switch (event.type) {
    case AUTH_BOOTSTRAP_FAILED:
      return {
        ...state,
        bootstrapFailed: true,
      }

    case AUTH_INITIALIZED:
      return {
        ...state,
        initialized: true,
        bootstrapFailed: false,
        currentUser: event.payload.user,
        currentOrganization: event.payload.organization,
        currentProfile: event.payload.profile,
      }

    case PROFILE_UPDATED:
      return {
        ...state,
        currentProfile: event.payload.profile,
      }

    // The sign out in the middle of a kiosk user switch must not end the switch.
    case SIGNED_OUT:
      return {
        ...defaultState,
        switchingUser: state.switchingUser,
      }

    case USER_SWITCH_STARTED:
      return { ...state, switchingUser: true }

    case USER_SWITCH_FINISHED:
      return { ...state, switchingUser: false }

    case START_MANAGING_ORG:
    case CURRENT_ORG_UPDATED:
      return { ...state, currentOrganization: event.payload.organization }

    default:
      return state
  }
}
